import React from 'react';
import { PrintContextImage } from './PrintContextImage';

type SourceShape = {
  quote?: string;
  reference?: string;
  imageUrl?: string;
  wikiQuery?: string;
  provenance?: string;
};

export type PrintSourceAnalysisPayload = {
  title?: string;
  source?: SourceShape;
  questions?: string[];
  imageUrl?: string;
};

function cleanQuote(quote: string): string {
  const raw = String(quote || '').trim();
  if (!raw) return '—';
  return raw.replace(/^[«"“]+|[»"”]+$/g, '').trim() || '—';
}

/**
 * Vista impresa de fuente primaria — estilo documento histórico (no muro de texto).
 */
export function PrintSourceAnalysis({ payload }: { payload: PrintSourceAnalysisPayload }) {
  const source = payload.source || {};
  const quote = cleanQuote(String(source.quote || ''));
  const reference = String(source.reference || '').trim();
  const imageUrl = String(payload.imageUrl || source.imageUrl || '').trim();
  const questions = Array.isArray(payload.questions)
    ? payload.questions.map((q) => String(q || '').trim()).filter(Boolean)
    : [];

  return (
    <div className="print-source-analysis">
      {payload.title ? <h3 className="print-source-analysis__title">{payload.title}</h3> : null}

      <figure className="print-source-analysis__document">
        <div className="print-source-analysis__document-inner">
          {imageUrl ? (
            <div className="print-source-analysis__media">
              <PrintContextImage imageUrl={imageUrl} alt={reference || payload.title || 'Fuente'} />
            </div>
          ) : null}
          <blockquote className="print-source-analysis__quote">«{quote}»</blockquote>
          {reference ? (
            <>
              <div className="print-source-analysis__rule" aria-hidden />
              <figcaption className="print-source-analysis__attribution">
                <span className="print-source-analysis__attribution-label">Procedencia</span>
                <span className="print-source-analysis__attribution-text">{reference}</span>
              </figcaption>
            </>
          ) : null}
        </div>
      </figure>

      {questions.length > 0 ? (
        <ol className="print-source-analysis__questions">
          {questions.map((question, index) => (
            <li key={`q-${index}`} className="print-source-analysis__question">
              <p className="print-source-analysis__question-text">
                {index + 1}. {question}
              </p>
              <div className="print-source-analysis__answer-lines" aria-hidden>
                <span />
                <span />
                <span />
              </div>
            </li>
          ))}
        </ol>
      ) : null}
    </div>
  );
}
